import React, { useEffect, useState } from "react"
import {
    Link,
    Redirect
} from "react-router-dom"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl"
import $ from "jquery"
import SideBar from "../../common/layout/sidebar.component.jsx"
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import IntlProps from "../../state/helpers/IntlProps"
import { RouteComponentProps } from "react-router"
import Template from "../../state/template/Template"
import { isError } from "../../state/helpers/Error"
import templateService from "../../state/template/TemplateService"
import LoadingSpinner from "../../common/spinner/loading.component"
import { TYPE_SMS } from "../../state/conversation/ConversationThreadTypes"
import { SMSTemplatePayload } from "../../state/template/TemplatePayload"

type PathParamsType = {
    templateKey: string,
    templateId: string,
}

type PropsType = RouteComponentProps<PathParamsType> & IntlProps & {
    templateKey: string,
    templateId: string,
}

type OwnProps = {
    isNew: boolean,
    templateKey: string,
}

const messages = defineMessages({
    "default_name": {
        id: "templates.default_template_name",
        defaultMessage: "Default template",
    },
    "save_btn": {
        id: "settings.sms.templates.form.edit.save_btn",
        defaultMessage: "Save",
    },
    "create_btn": {
        id: "settings.sms.templates.form.edit.create_btn",
        defaultMessage: "Create",
    },
    "subject_placeholder": {
        id: "settings.sms.template.form.edit.subject_placeholder",
        defaultMessage: "Subject of the SMS",
    },
    "name_placeholder": {
        id: "settings.sms.template.form.edit.name_placeholder",
        defaultMessage: "Name of the template",
    },
})

const SMSTemplatesEditForm = (props: OwnProps & IntlProps & PropsType) => {
    const [templateForm, setTemplateForm] = useState({
        subject: "",
        content: "",
        formStatus: <></>,
        name: props.intl.formatMessage(messages["default_name"]),
        status: "",
        isNew: props.isNew || false,
        templateKey: props.match ? props.match.params.templateKey : props.templateKey,
        templateId: props.match ? props.match.params.templateId : "",
        isLoading: true,
    })

    const [template, setTemplate] = useState<Template>()

    useEffect(() => {
        SideBar.activateMenu("sales-tools")
        templateService.findByTemplateKey(templateForm.templateId !== "" ?
            templateForm.templateId : templateForm.templateKey).then(res => {
            if (!isError(res)) {
                initializeFromRes(res)
            }
        })
    }, [])

    const initializeFromRes = (res: Template) => {
        setTemplate(res)
        setTemplateForm({
            ...templateForm,
            content: res.getContent(),
            name: res.getName(),
            status: res.getStatus(),
            templateKey: res.getTemplateKey(),
            isLoading: false,
        })
        $("#subject").focus()
    }

    const submitTemplate = (event) => {
        event.preventDefault()
        const templatePayload = {} as SMSTemplatePayload
        const allowedFormFields = ["content", "templateType", "name"]

        for (let i = 0; i < allowedFormFields.length; i++) {
            const field = allowedFormFields[i]
            if (templateForm.isNew || templateForm[field] != template?.getAttributes()[field]) {
                if (field == "templateType") {
                    templatePayload[field] = TYPE_SMS
                } else {
                    templatePayload[field] = templateForm[field]
                }
            }
        }

        if (!templateForm.isNew) {
            templateService.updateByTemplateKey(templatePayload, templateForm.templateId !== "" ?
                templateForm.templateId : templateForm.templateKey).then(res => {
                if (!isError(res)) {
                    setTemplateForm({
                        ...templateForm,
                        formStatus: <Redirect
                            to={{
                                pathname: !templateForm.templateId ?
                                    "/branding" : `/settings/sms-templates/${templateForm.templateKey}/listing`
                            }}/>
                    })
                }
            })
        } else {
            templateService.createTemplate(templatePayload, templateForm.templateKey).then(res => {
                if (!isError(res)) {
                    setTemplateForm({
                        ...templateForm,
                        formStatus: <Redirect
                            to={{pathname: `/settings/sms-templates/${templateForm.templateKey}/listing`}}/>
                    })
                }
            })
        }
    }

    const deleteTemplate = (event) => {
        event.preventDefault()
        templateService.deleteByTemplateId(templateForm.templateId).then(res => {
            if (!isError(res)) {
                setTemplateForm({
                    ...templateForm,
                    formStatus: <Redirect
                        to={{pathname: `/settings/sms-templates/${templateForm.templateKey}/listing`}}/>
                })
            }
        })
    }

    const handleNameChange = (event) => {
        setTemplateForm({
            ...templateForm,
            name: event.target.value
        })
    }

    const handleRichTextChange = (event) => {
        setTemplateForm({
            ...templateForm,
            content: event.target.value
        })
    }
    return (
        <div>
            {templateForm.isLoading ?
                <LoadingSpinner/> :
                <form onSubmit={submitTemplate}>
                    <div className="row ui-has-modules">
                        <div className="col-12 ui-module">
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="name">
                                    <FormattedMessage
                                        id="settings.sms.template.form.edit.name_label"
                                        defaultMessage="Name"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        name="name"
                                        value={templateForm.name}
                                        onChange={handleNameChange}
                                        id="name"
                                        type="text"
                                        maxLength={25}
                                        className="form-control"
                                        placeholder={props.intl.formatMessage(messages["name_placeholder"])}
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.sms.template.form.edit.name_description"
                                            defaultMessage="Name of the template"
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="content">
                                    <FormattedMessage
                                        id="settings.sms.template.form.edit.content_label"
                                        defaultMessage="Content"
                                    />
                                </label>
                                <div className="col-10">
                                    <textarea
                                        rows={20}
                                        name="content"
                                        value={templateForm.content}
                                        onChange={handleRichTextChange}
                                        id="content"
                                        className="form-control"
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.sms.template.form.edit.content_description"
                                            defaultMessage="Content of the SMS"
                                        />
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            {templateForm.formStatus}
                        </div>
                        <div className="col-12 ui-module">
                            <div className="row">
                                <div className="col-6 text-align-left">
                                    {!templateForm.isNew && templateForm.templateId && templateForm.status !== "default" &&
                                        <ConfirmButton identifier={templateForm.name} onClick={deleteTemplate}
                                            className="btn btn-danger">
                                            <FormattedMessage
                                                id="settings.emails.templates.form.edit.delete_btn"
                                                defaultMessage="Delete"
                                            />
                                        </ConfirmButton>
                                    }
                                </div>
                                <div className="col-6 text-align-right">
                                    <Link
                                        to={!templateForm.templateId ?
                                            "/branding" : `/settings/sms-templates/${templateForm.templateKey}/listing`}
                                        className="btn btn-light">
                                        <FormattedMessage
                                            id="settings.sms.template.form.cancel_btn"
                                            defaultMessage="Cancel"
                                        />
                                    </Link>
                                    &nbsp;
                                    &nbsp;
                                    <input type="submit"
                                        value={props.intl.formatMessage(messages[
                                            !templateForm.isNew ? "save_btn" : "create_btn"
                                        ])}
                                        className="btn btn-primary"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            }
        </div>
    )
}

export default injectIntl(SMSTemplatesEditForm)


// WEBPACK FOOTER //
// ./src/settings/sms/editSMSTemplateForm.tsx